import { Modal } from '@mui/material';
import { useContext } from 'react';
import { ViContext } from '../../context/ViContext';

export default function Resource(props) {
	return (
		<Modal open={props.open} onClose={() => props.setOpen(false)}>
			{/* <!-- 데이터 출처 모달 팝업 --> */}
			<section className="modalSection" tabIndex="-1">
				<div className="modalPaper">
					<div className="modalHead">
						<div type="button" className="tit">
							<img src="img/headerIcon02.png" alt="icon" />
							데이터 출처
						</div>
						<button
							className="closeIconButton"
							onClick={() => props.setOpen(false)}
						>
							<img src="img/popCloseBtn.png" alt="닫기" />
						</button>
					</div>

					<div className="modalBody">
						<div className="HeadingBox">
							<h2 className="text-heading-mi">시군구 단위 지역활력지수</h2>
						</div>

						<div className="dataSourceTable indent">
							<table style={{ wordBreak: 'keep-all' }}>
								<thead>
									<tr>
										<th>영역</th>
										<th>시군구단위 세부지표</th>
										<th>구축대상 년도</th>
										<th>데이터 출처 및 설명</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td rowSpan="3">인구 활력</td>
										<td>
											L1-1 경제활동인구
											<br />
											(단위: 명)
										</td>
										<td>2021</td>
										<td>
											<p>
												- 통계청 경제활동인구수는 만 15세 이상 인구 중 조사 대상
												기간 동안 상품이나 서비스를 생산하기 위해 실제로 수입이
												있는 일을 한 취업자와 일을 하지는 않았지만 구직활동을 한
												실업자의 합
											</p>
											<p>
												-특광역시 구(군)지역의 경제활동인구수는 2021년
												상반기부터 공표
											</p>
											<p>
												-생산가능인구는 2021년 공표된 통계청
												생산연령인구(15-64세) 데이터 활용
											</p>
										</td>
									</tr>
									<tr>
										<td>
											L1-2 학령인구
											<br />
											(단위: 명)
										</td>
										<td>2021</td>
										<td>- 통계청 학령인구통계(만 6세~21세 인구수)</td>
									</tr>
									<tr>
										<td>
											L1-3 체류인구
											<br />
											(단위: 명)
										</td>
										<td>2021</td>
										<td>
											<p>
												- 통계청이 공개중인 통신모바일 인구이동량 통계를
												활용하여 1년치 관내 및 관외 인구를 합산
											</p>
											<p>
												-민간 빅데이터(SKT)를 활용하여 관내 및 관외에서 해당
												행정동을 방문하여 30분 이상 체류 ß
											</p>
										</td>
									</tr>
									<tr>
										<td rowSpan="3">소비 활력</td>
										<td>
											L1-4 소매업 및 음식/주점업 월매출액
											<br />
											(단위: 천원)
										</td>
										<td>2021</td>
										<td>
											<p>- 전국 행정동 단위 KCB 데이터</p>
											<p>
												- 표준산업분류코드 중분류(자동차를 제외한 소매업종,
												음식점 및 주점업) 월매출액 합계
											</p>
											<p>- 행정동 단위 데이터를 시군구로 가공하여 활용</p>
										</td>
									</tr>
									<tr>
										<td>
											L1-5 소득
											<br />
											(단위: 백만원)
										</td>
										<td>2020</td>
										<td>
											<p>
												- 시나리오 1의 소득은 국세청의 국세통계 2021 총수입금액
												자료를 활용
											</p>
											<p>
												- 시나리오 2의 소득은 KCB의 자택주소 기준 개인 총소득
												월환산금액 합계(2021.6)를 활용
											</p>
										</td>
									</tr>
									<tr>
										<td>
											L1-6 소비
											<br />
											(단위: 십만원)
										</td>
										<td>2021</td>
										<td>
											<p>
												- KCB의 자택주소 기준 최근 3개월간 이용한 총
												카드이용금액의 합계
											</p>
											<p>- 21년 4, 5, 6월 신용 및 체크카드 이용금액 합계</p>
										</td>
									</tr>
									<tr>
										<td rowSpan="4">소비 활력</td>
										<td>
											L1-7 사업체 매출액
											<br />
											(단위: 백만원)
										</td>
										<td>2020</td>
										<td rowSpan="2">
											- 시군구 단위는 통계청이 제공하는 행정통계
											(기업통계등록부(2010~2020))를 가공하여 활용
										</td>
									</tr>
									<tr>
										<td>
											L1-8 사업체 개수
											<br />
											(단위: 개)
										</td>
										<td
											style={{
												textAlign: 'center',
											}}
										>
											2020
										</td>
									</tr>
									<tr>
										<td>
											L1-9 인력수요로 본 일자리 수<br />
											(단위: 개)
										</td>
										<td>2022.10</td>
										<td>
											- 통계청이 워크넷, 인크루트, 사람인 구인정보를 바탕으로
											구인업체수를 집계한 것(통계청 일자리맵)
										</td>
									</tr>
									<tr>
										<td>
											L1-10 개인사업자 창업율
											<br />
											(단위: %)
										</td>
										<td>2020</td>
										<td>
											<p>- 국세청 국세통계 2021 정보를 바탕으로 산출</p>
											<p>
												- 창업률 : (개인사업자의 신규사업자수 ÷ 가동사업자수) ×
												100
											</p>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div className="Content">
							※ 국세통계 2021은 2021.12.31.에 공표한 데이터로, 2020년을 대상으로
							산출
						</div>

						<div className="dotLine" />

						<div className="HeadingBox">
							<h2 className="text-heading-mi">읍면동 단위 지역활력지수</h2>
						</div>

						<div className="dataSourceTable">
							<table>
								<thead>
									<tr>
										<th>영역</th>
										<th>의미</th>
										<th>읍면동 단위 세부지표</th>
										<th>데이터 출처 및 설명</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td rowSpan="2">인구 활력</td>
										<td rowSpan="2">생산과 소비활동 주체의 규모</td>
										<td>
											L2-1 생산가능인구수
											<br />
											(단위: 명)
										</td>
										<td>
											만15세에서 만64세까지의 경제활동 가능한 인구의 규모 :
											잠재적 경제활동 인구가 많은 지역은 인구활력이 높음
										</td>
									</tr>
									<tr>
										<td>
											L2-2 학령인구수
											<br />
											(단위: 명)
										</td>
										<td>
											만6세에서 만21세까지의 학령인구의 규모 : 학령인구를 포함한
											가구가 소비 지출이 높은 편임
										</td>
									</tr>
									<tr>
										<td rowSpan="2">인구 활력</td>
										<td rowSpan="2">인구 활력</td>
										<td>
											L2-3 총수입금액
											<br />
											(단위: 십만원)
										</td>
										<td>
											KCB 데이터 : 추정소득 - 읍면동단위 KCB데이터(2021.6)
											자택주소 기준 : 개인 총수입 규모가 클수록 소비활력이 큼
										</td>
									</tr>
									<tr>
										<td>
											L2-4 개인카드사용 총액
											<br />
											(단위: 십만원)
										</td>
										<td>
											개인카드이용 총금액 합계 - 읍면동단위 KCB데이터(2021.6)
											자택주소 기준 : 개인카드 이용금액이 클수록 소비활력이 큼
										</td>
									</tr>
									<tr>
										<td rowSpan="2">인구 활력</td>
										<td rowSpan="2">인구 활력</td>
										<td>
											L2-5 구인사업체수
											<br />
											(단위: 개)
										</td>
										<td>
											구인공고를 한 사업체 수(잠재적 일자리 발생) - 통계청
											일자리맵구인희망 업체수, 통계청, 2022. : 구인공고 중인
											사업체들은 생산성이 유지되거나 증가하고 있어 생산활력이
											높음
										</td>
									</tr>
									<tr>
										<td>
											L2-6 가맹점 카드매출액
											<br />
											(3대 업종)
											<br />
											(단위: 천원)
										</td>
										<td>
											<p>
												KCB 데이터-추정 월매출액 합계 : 자동차를 제외한
												소매업종, 음식점, 주점업(표준산업분류코드 중분류 단위)의
												카드매출액
											</p>
											<p>
												*전국 행정동에 고르게 분포하는 소매업종과 음식점 및
												주점업만 활용
											</p>
											<p>
												*기업매출의 경우 본사 위치로 매출액이 잡히는 등데이터
												해석 관련 왜곡 발생우려로 사업체 매출은 미반영
											</p>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div className="Content">
							※ 읍면동 데이터는 행정동 기준으로 데이터를 융합하였으며, 행정구역
							경계 변경으로 인한 일부 지역의 데이터 손실이 있을 수 있음
						</div>
					</div>
				</div>
			</section>
		</Modal>
	);
}
